import React from "react";
import { motion } from "framer-motion";
import styled from "styled-components";
import { staggerContainer } from "../../utils/motion";

const StyledSection = styled(motion.section)`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 0;
  padding: 40px 24px;
  @media (max-width: 768px) {
    padding: 24px 16px;
  }
`;

const HashSpan = styled.span`
  display: block;
  margin-top: -100px;
  padding-bottom: 100px;
  pointer-events: none;
`;

const SectionWrapper = (Component, idName) =>
  function HOC() {
    return (
      <StyledSection
        variants={staggerContainer(0.2, 0.1)}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.25 }}
      >
        <HashSpan id={idName}>&nbsp;</HashSpan>
        <Component />
      </StyledSection>
    );
  };

export { SectionWrapper };
